<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-user"></i> Usuário
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                  class="col-md-4 mb-3" :class="{ 'dropdown-has-error': $v.model.id_pais.$error }" >
                                  <label>País*</label>
                                  <select-api
                                      ref="selectPais"
                                      v-model="model.id_pais"
                                      :endpoint="'/pais/pesquisa'"
                                      :opt-text="'nome'"
                                      :select-option="true"
                                     
                                  ></select-api>
                              </div>
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.nome"
                                        @input="$v.model.nome.$touch()"
                                    />
                                </div>
                                <div
                                    class="col-md-2"
                                    :class="{ 'has-danger': $v.model.email.$error }"
                                >
                                    <label>E-mail*</label>
                                    <input
                                        type="email"
                                        :readonly="model.id"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.email"
                                        @input="$v.model.email.$touch()"
                                    />
                                </div>
                                <div
                                    class="col-md-2"
                                    :class="{ 'has-danger': $v.model.telefone.$error }"
                                >
                                    <label>Telefone*</label>
                                    <masked-input
                                        v-model.trim="model.telefone"
                                        mask="(11) 11111-1111"
                                        class="form-control"
                                    ></masked-input>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.cpf.$error }"
                                >
                                    <label>CPF*</label>
                                    <masked-input
                                        v-model.trim="model.cpf"
                                        mask="111.111.111-11"
                                        class="form-control"
                                    ></masked-input>
                                </div>
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.nascimento.$error }"
                                >
                                    <label>Data de Nascimento*</label>
                                    <input-datepicker
                                        :disabled="false"
                                        :readonly="false"
                                        :group="false"
                                        :autoclose="true"
                                        v-model="model.nascimento"
                                        @input="$v.model.nascimento.$touch()"
                                    ></input-datepicker>
                                </div>

                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.sexo.$error }"
                                >
                                    <label>Sexo*</label>
                                    <select2
                                        :options="sexos"
                                        v-model="model.sexo"
                                        placeholder="Selecione um sexo"
                                        :select-option="true"
                                    >
                                        <option value selected>Selecione um sexo</option>
                                    </select2>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Senha</label>
                                    <input
                                        type="password"
                                        maxlength="30"
                                        class="form-control"
                                        v-model="model.senha"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>Perfil*</label>
                                    <dw-select
                                        :options="profiles"
                                        v-model="model.perfil"
                                        opt-text="nome"
                                        placeholder="Selecione um perfil"
                                    >
                                        <option value="0" selected>Selecione um perfil</option>
                                    </dw-select>
                                </div>
                                <div class="col-md-4">
                                    <label>Data de Criação*</label>
                                    <input-datepicker
                                        :disabled="true"
                                        :readonly="true"
                                        :group="false"
                                        :autoclose="true"
                                        v-model="model.criado_em"
                                    ></input-datepicker>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-3">
                                    <label>Ativo</label>
                                    <input-toggle v-model="model.ativo" :value="model.ativo"></input-toggle>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-footer text-right">
                            <router-link :to="{ name: 'list-user' }" class="btn btn-link">Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";

const facade = new Facade();

import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isUndefinedOrNullOrEmpty,
    isNotUndefinedOrNullOrEmptyOrZero,
    formatPhone,
    formatCpf,
    clearCpfCnpj
} from "@/services/string";
import { isPhone, isCpf, validateCPF } from "@/services/util";
import Collections from "../../helpers/collections";
import SelectApi from "../../components/Input/SelectApi";
import Select2 from '../../components/Input/Select2';

export default {
    components: {
      SelectApi, Select2
    },
    
    data() {
        return {
            pais: null,
            model: {
                nome: "",
                cpf: "",
                telefone: "",
                senha: "",
                email: "",
                id_pais: 0,
                nascimento: moment().format("YYYY-MM-DD"),
                ativo: true,
                perfil: "0",
                sexo: "",
                criado_em: moment().format("YYYY-MM-DD")
            },
            profiles: [],
            sexos: []
        };
    },
    validations() {
        return {
            model: {
                perfil: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                },
                nome: {
                    required,
                    minLength: minLength(2)
                },
                email: {
                    required,
                    email,
                    minLength: minLength(5)
                },
                telefone: {
                    required,
                    isPhone
                },
                nascimento: {
                    required
                },
                sexo: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                },
                cpf: {
                    required,
                    validateCPF,
                    isCpf
                },
                id_pais: {
                    required
                }
            }
        };
    },
    methods: {
        save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);
            if (vm.model.id) {
                let ret = facade.updateUser(vm.model);
                ret.then(user => {
                    this.$router.push({ name: "list-user" });
                    this.$loading.show(false);
                }).catch(e => {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                });
            } else {
                let ret = facade.createUser(vm.model);
                ret.then(user => {
                    this.$router.push({ name: "list-user" });
                    this.$loading.show(false);
                }).catch(e => {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                });
            }
        },
        setData(user) {
            let vm = this;
            if (user !== undefined && user !== null) {
                user.telefone = user.telefone ? formatPhone(user.telefone) : "";
                user.cpf = formatCpf(user.cpf);

                vm.model = user;
                vm.model.senha = null;
            }

            this.profiles = Collections.perfisUsuarioAdmin;
            this.sexos = Collections.sexos;
        }
    },
    beforeRouteEnter(to, from, next) {
        const vm = this;
        Promise.all([to.params.id ? facade.getUser(to.params.id) : null])
            .then(response => {
                next(vm =>
                    vm.setData(
                        response[0] != null ? response[0].data.data : null
                    )
                );
            })
            .catch(e => {
                next(vm => vm.setData());
            });
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?7816a961